module.exports = __webpack_public_path__ + "static/fonts/yxl-font.2b69d90.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/yxl-font.eot?hash=1531290333696
// module id = 1898
// module chunks = 115